var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAuth, withAuth } from '@lib/hooks';
export const useAuthWithSignup = () => {
    const auth = useAuth();
    const createSetupIntentAndMaybeSignup = withAuth((email, charityId) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield fetch('/api/payment_methods', {
            method: 'POST',
            body: JSON.stringify({
                email,
                charityId
            })
        });
        if (res.status !== 200) {
            throw new Error(`Unexpected status ${res.status}`);
        }
        const data = yield res.json();
        if (data.success) {
            auth._setUser({
                email: data.email,
                expires: data.expires,
                firstName: data.firstName,
                lastName: data.lastName,
                userId: data.userId
            });
        }
        return data.client_secret;
    }));
    return Object.assign(Object.assign({}, auth), { createSetupIntentAndMaybeSignup });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQXV0aFdpdGhTaWdudXAuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsiaG9va3MvdXNlQXV0aFdpdGhTaWdudXAudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBYSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sWUFBWSxDQUFBO0FBTXpELE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLEdBQW1CLEVBQUU7SUFDcEQsTUFBTSxJQUFJLEdBQUcsT0FBTyxFQUFFLENBQUE7SUFFdEIsTUFBTSwrQkFBK0IsR0FBRyxRQUFRLENBQUMsQ0FBTyxLQUFhLEVBQUUsU0FBaUIsRUFBbUIsRUFBRTtRQUMzRyxNQUFNLEdBQUcsR0FBRyxNQUFNLEtBQUssQ0FBQyxzQkFBc0IsRUFBRTtZQUM5QyxNQUFNLEVBQUUsTUFBTTtZQUNkLElBQUksRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDO2dCQUNuQixLQUFLO2dCQUNMLFNBQVM7YUFDVixDQUFDO1NBQ0gsQ0FBQyxDQUFBO1FBRUYsSUFBSSxHQUFHLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRTtZQUN0QixNQUFNLElBQUksS0FBSyxDQUFDLHFCQUFxQixHQUFHLENBQUMsTUFBTSxFQUFFLENBQUMsQ0FBQTtTQUNuRDtRQUVELE1BQU0sSUFBSSxHQUFxSSxNQUFNLEdBQUcsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUMvSixJQUFJLElBQUksQ0FBQyxPQUFPLEVBQUU7WUFFaEIsSUFBSSxDQUFDLFFBQVEsQ0FBQztnQkFDWixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7Z0JBQ2pCLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTztnQkFDckIsU0FBUyxFQUFFLElBQUksQ0FBQyxTQUFTO2dCQUN6QixRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVE7Z0JBQ3ZCLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTTthQUNwQixDQUFDLENBQUE7U0FDSDtRQUVELE9BQU8sSUFBSSxDQUFDLGFBQWEsQ0FBQTtJQUMzQixDQUFDLENBQUEsQ0FBQyxDQUFBO0lBRUYsdUNBQVksSUFBSSxLQUFFLCtCQUErQixJQUFFO0FBQ3JELENBQUMsQ0FBQSJ9